import $ from 'jquery'
import _ from 'lodash'
import text from './text'
import purify from './purify'
import 'bootstrap'
import 'selectize'
import 'datatables'
import 'datatables-bootstrap3-plugin'
import linkClick from './link-click'

var defaults = {
  ctx: '',
  lang: 'en',
  initHidden: false,
  server: false,
  show_only: false,
  show_only_max: 3,
  lengthMenu: [5, 10, 20, 50],
  pageLength: 10,
  dom: 'lfrtip',
  order: undefined,
  query: undefined, // only relevant if server==true
  successCallback: function () {},
  errorCallback: function () {},
  idleCallback: function () {},
  busyCallback: function () {},
  useViews: false,
  viewCallback: function () {},
  showDetails: false, // only relevant if useViews==false
  fixedData: false, // only relevant if useViews==false and server==false
  parameterPrefix: '', // mandatory if server==true
  thead: undefined, // only relevant if useViews==true
  clickonrow: false, // click on row redirects to entity-url-template
  middleclickonrow: false, // middle-click on row redirects to entity-url-template
  clicktoselect: false, // double-click to select a row
  selectCallback: undefined, // only relevant if clicktoselect==true
  unselectCallback: undefined, // only relevant if clicktoselect==true
  selectedElem: undefined, // only relevant if clicktoselect==true
  updateRowUrl: undefined,
  $counter: undefined,
  changePageCallback: undefined,
  drawCallback: undefined,
  elem: undefined,
}

export default {
  init: function (opts) {
    var onComplete = function () {
      if (D.initHidden) {
        hide()
      }
      if (!D.server && D.query !== undefined) {
        console.log('tables::Fetching default search results')
        D.busyCallback(D)
        $.ajax($.extend(D.query, {
          success: successWrapper,
          error: errorWrapper,
        }))
      }
    }

    var errorWrapper = function (jqXHR, textStatus, errorThrown) {
      D.errorCallback(jqXHR, textStatus, errorThrown)
      D.idleCallback(D)
    }

    var successWrapper = function (response) {
      D.successCallback(response)
      D.idleCallback(D)
    }

    var refresh = function (paging) {
      var resetPage = paging === true || paging === 'full-reset'
      var page = D.dt.page()
      var newPage = page
      console.log('tables::Page before refresh: ' + page)
      if (!resetPage && D.server && D.dt.data().length == 0) {
        console.log('tables::Number of rows in current page is 0, redraw previous page')
        newPage = Math.max(0, page - 1)
        console.log('tables::Predicted page: ' + newPage)
        D.dt.page(newPage)
      } else if (!resetPage && !D.server) {
        var info = D.dt.page.info()
        D.dt.page(Math.min(Math.ceil(info.recordsDisplay / info.length) - 1, newPage))
      }
      D.dt.draw(paging)
      return handler
    }

    var hide = function () {
      console.log('tables::Hiding the table')
      $(D.dt.table().container()).hide()
    }

    var show = function () {
      console.log('tables::Unhiding the table')
      $(D.dt.table().container()).show()
    }

    var cid = function () {
      console.log('tables::cid')
      return $('input[name=cid]').val()
    }

    var determineIdOfRowEvent = function (_this) {
      console.log('tables::click in tr')
      if ($(_this).hasClass('dataTables_empty')) {
        console.log('tables:: empty row')
        return
      }
      var data

      if (D.useViews) {
        var index = D.dt.row(_this).index()
        console.log('tables::clicked on the row of entity (' + index + ')')
        data = D.dt.row(index).data()
      } else {
        var indexes = D.dt.cell(_this).index()

        console.log('tables::clicked on the row of entity (' +
            indexes.row + ',' + indexes.column + ')')
        data = D.dt.row(indexes.row).data()
      }
      return data
    }

    var onClickSelect = function () {
      var data = determineIdOfRowEvent(this)
      var $this = $(this)
      if (D.selectedElem !== undefined && $this.get(0) === D.selectedElem.get(0)) {
        if (D.unselectCallback !== undefined) {
          D.unselectCallback(data, handler, $this)
          D.selectedElem = undefined
        }
      } else {
        var $prev = D.selectedElem

        D.selectedElem = $this
        if (D.selectCallback !== undefined) {
          D.selectCallback(data, handler, $this, $prev)
        }
      }
    }

    var onMiddleClick = function () {
      var data = determineIdOfRowEvent(this)
      var url = D.elem.data('middle-click-url-template')
      if (url === undefined || url === '') {
        console.error('tables::middle-click-url-template is undefined/empty')
        return
      }
      url = url.replace('_ID_', data.id).replace('_PID_', cid())
      console.log('tables::' + url)
      linkClick(url, true)
    }

    var onClickNoButton = function (e) {
      if (e.metaKey) {
        console.log('tables::pressed meta key, will assume a onMiddleClick')
        return
      }
      var data = determineIdOfRowEvent(this)
      var url = D.elem.data('entity-url-template')
      if (url === undefined || url === '') {
        console.error('Table:entity-url-template is undefined/empty')
        return
      }
      url = url.replace('_ID_', data.id).replace('_PID_', cid())
      console.log('tables::' + url)
      linkClick(url)
    }

    var onClickButton = function () {
      var $b = $('span', this)
      var r = D.dt.row($b.closest('tr'))
      if (r.child.isShown()) {
        r.child.hide()
        $b.removeClass('glyphicon-minus')
        $b.addClass('glyphicon-plus')
      } else {
        var details = _(r.data()).omit(_(D.spec).map('data').push('id').value())
        $detailsHtml = $('<div/>')
        if (r.data().view !== undefined) {
          $('<span/>').html(r.data().view).appendTo($detailsHtml)
        } else if (details.isEmpty()) {
          $('<span/>').text('No data.').appendTo($detailsHtml)
        } else {
          details.each(function (v, k) {
            $detailsHtml.append($('<tr/>')
              .append($('<td>').attr('role', 'gridcell')
                .html(k))
              .append($('<td>').attr('role', 'gridcell')
                .html(v)))
          })
        }
        r.child($detailsHtml).show()
        $b.removeClass('glyphicon-plus')
        $b.addClass('glyphicon-minus')
      }
    }

    var resultsGetSuccess = function (callback, dtParams) {
      return function (response) {
        console.log('tables::Executing user-supplied callback')
        if (response.data === undefined || !_.isArray(response.data.data)) {
          console.log('tables::Response had no data property')
          console.log('tables::Executing rest of no data handling')
          console.log(response)
          callback({
            draw: dtParams.draw,
            recordsTotal: 0,
            recordsFiltered: 0,
            data: {},
            error: text('error.ajax'),
          })
          D.successCallback(response)
          return
        }
        if (D.$counter !== undefined) {
          console.log('tables::Updating the counter to value:')
          D.$counter.text(response.data.recordsTotal)
        }
        callback(response.data)
        D.successCallback(response)
        D.idleCallback(D)
      }
    }

    var resultFetcher = function (dtParams, callback, settings) {
      D.busyCallback(D)
      var customReq = _.result(D, 'query')
      console.log('tables::Custom request data are:')
      console.log(customReq)
      console.log('tables::DataTables passed these request data:')
      console.log(dtParams)
      var request = _.clone(customReq)
      var prefixedDtParams = {}
      _(dtParams).forIn(function (v, k) {
        prefixedDtParams[D.parameterPrefix + k] = v
      })
      request.data += '&' + $.param(prefixedDtParams)
      request.data += '&' + $.param(prefixedDtParams)
      $.extend(request, {
        success: resultsGetSuccess(callback, dtParams),
        error: errorWrapper,
      })
      console.log('tables::Final request data are:')
      console.log(request)
      $.ajax(request)
    }

    var D = $.extend({}, defaults, opts || {})
    console.log('tables::Table:init', D)
    if (D.elem === undefined || D.elem === '') {
      console.error('Table:elem cannot be undefined/empty', D)
      return
    }
    if (typeof D.elem === 'string') {
      D.elem = $(D.elem)
    }
    if (D.elem.length === 0) {
      console.error('Table:elem does not exist', D)
      return
    }

    if (D.server) {
      D.parameterPrefix = D.elem.data('parameter-prefix')
      if (D.parameterPrefix === undefined || D.parameterPrefix === '') {
        console.error('Table: must set parameter-prefix in data')
      }
    }

    D.show_only = D.elem.data('show-only') || D.show_only
    D.show_only_max = D.elem.data('show-only-max') || D.show_only_max
    D.spec = D.elem.data('columnsspec') || []
    if (!D.useViews && !D.fixedData && _.isEmpty(D.spec)) {
      console.error('Table: must set columnsspec in data')
    }
    if (D.fixedData && (D.useViews || D.server || !_.isEmpty(D.spec) || D.order)) {
      console.error('Table: fixedData is mutually exclusive with useViews, server and order')
    }

    _(D.spec).each(function (e) {
      e.defaultContent = ''
    })

    var conf = {
      language: D.lang,
      processing: true,
      deferRender: true,
      serverSide: D.server,
      searching: !D.server,
      initComplete: onComplete,
    }

    $.extend(conf, { lengthMenu: D.lengthMenu })
    $.extend(conf, { pageLength: D.pageLength })
    $.extend(conf, { dom: D.dom })
    $.extend(conf, { order: D.order || (D.spec ? [[0, 'asc']] : undefined) })

    if (D.show_only) {
      $.extend(conf, {
        lengthMenu: [[D.show_only_max], [D.show_only_max]],
        pageLength: D.show_only_max,
        dom: 't',
      })
    }
    if (D.server) {
      $.extend(conf, { ajax: resultFetcher })
    }

    if (D.useViews && !conf.searching) {
      $.extend(conf, {
        columns: [
          {
            class: '',
            orderable: false,
            data: undefined,
            createdCell: function (td, cellData, rowData, row, col) {
              $(td).attr('role', 'gridcell').html(rowData.view)
            },
            defaultContent: '',
          },
        ],
        autoWidth: false,
        ordering: false,
      })
    } else if (D.useViews && conf.searching) {
      $.extend(conf, {
        columns: D.spec,
        autoWidth: false,
        ordering: !_.isEmpty(_.flatten(D.order)),
        rowCallback: function (row, data) {
          $(row).html($('<td>').attr('role', 'gridcell').html(data.view))
          D.viewCallback($(row), data)
        },
      })
    } else if (D.fixedData) {
      $.extend(conf, {
        columns: [[]],
        autoWidth: false,
        ordering: false,
      })
    } else if (D.showDetails) {
      $.extend(conf, {
        columns: [
          {
            class: 'button-column col-md-1',
            orderable: false,
            data: null,
            defaultContent: '<button type="button" ' +
              'class="toggle-details btn btn-primary btn-xs">' +
              '<span class="glyphicon glyphicon-plus"></span>' +
              '</button>',
          },
        ].concat(D.spec),
        autoWidth: false,
        ordering: !_.isEmpty(_.flatten(D.order)),
      })
    }

    if (!D.useViews && 'columns' in conf) {
      _.each(conf.columns, function (e) {
        if ('render' in e && !_.isEmpty(e.render)) {
          console.warn('Overwriting property columns.render of the configuration')
        }
        e.render = function (data, type, row, meta) {
          if (!_.isEmpty(data)) {
            data = purify.run(data)
          }
          return data
        }
      })
    }
    D.dt = D.elem.DataTable(conf)
    D.elem.on('init.dt', function () {
      var elem = $(D.dt.table().container()).find('select')
      elem.selectize({
        copyClassesToDropdown: false,
        onInitialize: function () {
          console.log('onInitialize')
          elem.find('+.selectize-control').removeClass('form-control')
          elem.find('+.selectize-control input').attr('role', 'presentation')
        },
      })

      // $(D.dt.table().container()).find('select').selectize({
      //   onInitialize: function () {

      //     // this adds a title to the input
      //     p = D.elem.closest('.dataTables_wrapper')
      //     p.find('.dataTables_length input').attr('title', text('table.size'))

      //     // this changes the label into a div with same contents
      //     l = p.find('.dataTables_length label')
      //     l.replaceWith('<div>' + l.html() + '</div>')
      //   },
      // })
    })
    D.elem.on('draw.dt', function () {
      var t = $(D.dt.table().container())
      var x = t.find('.paginate_button a')
      x.each(function () {
        $(this).html('<span class="audible hidden">' + text('table.page') +
          '</span>' + $(this).html())
      })
      x = t.find('.paginate_button.disabled')
      x.attr('aria-hidden', 'true')
      t.find('thead tr').attr('role', 'presentation')
      if (!D.server && D.drawCallback) {
        D.drawCallback(handler)
      }
    })
    if (!D.server && D.changePageCallback) {
      D.elem.on('page.dt', function () {
        D.changePageCallback(handler)
      })
    }

    if (D.useViews) {
      if (D.thead !== undefined) {
        $(D.dt.table().header()).replaceWith(D.thead)
      } else {
        $(D.dt.table().header()).hide()
      }
      if (D.clickonrow === true) {
        D.elem.on('click', 'tr', onClickNoButton)
      }
      if (D.clicktoselect === true) {
        D.elem.on('dblclick', 'tr', onClickSelect)
      }
    } else {
      if (D.showDetails === true) {
        D.elem.on('click', 'button.toggle-details', onClickButton)
      }
      if (D.clickonrow === true) {
        D.elem.on('click', 'td:not(".button-column")', onClickNoButton)
      }
      if (D.clicktoselect === true) {
        D.elem.on('dblclick', 'td:not(".button-column")', onClickSelect)
      }
    }

    var middleClickWho = undefined
    if (D.middleclickonrow === true) {
      D.elem.on('mousedown', 'tr', function (e) {
        if (e.which == 2 || (e.which == 1 && e.metaKey)) {
          middleClickWho = e.target
        }
      })
      D.elem.on('mouseup', 'tr', function (e) {
        if ((e.which == 2 || (e.which == 1 && e.metaKey)) && e.target === middleClickWho) {
          onMiddleClick.call(this)
        }
      })
    }

    var handler = {
      clear: function () {
        D.dt.clear().draw()
        return handler
      },
      add: function (data, paging) {
        if (_.isArray(data)) {
          D.dt.rows.add(data)
        } else {
          D.dt.row.add(data)
        }
        refresh(paging)
        return handler
      },
      remove: function (rowSelector, paging) {
        D.dt.row(rowSelector).remove()
        refresh(paging)
        return handler
      },
      update: function (rowSelector, paging, callback) {
        if (D.updateRowUrl === undefined) {
          console.warn('tables::updateRowUrl has to be set to call update()')
          return handler
        }
        var row = D.dt.row(rowSelector)

        var data = row.data()

        console.log('tables::Refreshing row id=' + data.id)
        var url = D.updateRowUrl.replace('_ID_', data.id).replace('_PID_', cid())
        $.getJSON(url, function (response) {
          if (response.data !== undefined) {
            console.log('tables::Received update for row id=' + data.id)
            row.data(response.data)
            if (D.updateRowUrl !== undefined && D.server && D.useViews) {
              $(row.node()).html($('<td>').attr('role', 'gridcell').html(response.data.view))
              if (paging != false) {
                refresh(paging)
              }
            } else {
              refresh(paging)
            }
            if (callback !== undefined) {
              callback(response)
            }
          } else {
            console.warn('tables::Cannot refresh row id=' + data.id)
          }
        })
        return handler
      },
      fetch: function (id, paging, callback) {
        if (D.updateRowUrl === undefined) {
          console.log('tables::updateRowUrl has to be set to call fetch()')
        }

        console.log('tables::Fetching entity id=' + id)
        var url = D.updateRowUrl.replace('_ID_', id).replace('_PID_', cid())
        $.getJSON(url, function (response) {
          console.log('tables::Received entity id=' + id)
          D.dt.row.add(response.data)
          if (callback !== undefined) {
            callback(response)
          }
          refresh(paging)
        })
        return handler
      },
      row: function (rowSelector) {
        return D.dt.row(rowSelector)
      },
      rowByDataId: function (id) {
        return D.dt.row(function (idx, data, node) {
          return data.id == id ? true : false;
        })
      },
      updateQuery: function (query) {
        if (!D.server) {
          return
        }
        D.query = query
        console.log('tables::Updating ajax query of table: ' + D.query)
        return handler
      },
      getData: function (key) {
        return D.elem.data(key)
      },
      setData: function (key, value) {
        return D.elem.data(key, value)
      },
      dt: function () {
        return D.dt
      },
      refresh: function (paging) {
        refresh(paging)
        return handler
      },
      getSelected: function () {
        return D.selectedElem
      },
      reload: function () {
        if (!D.server && D.query !== undefined) {
          $.ajax($.extend(D.query, {
            success: successWrapper,
            error: errorWrapper,
          }))
          return handler
        } else {
          return refresh(true)
        }
      },
      show: function () {
        show()
        return handler
      },
      hide: function () {
        hide()
        return handler
      },
      elem: function () {
        return D.elem
      },
    }
    return handler
  },
}
